<template>
    <div>
        <span v-if="!readMoreActivated">{{this.visibleText}}</span>
        <br />
         <div class="divbutton">
            <a class="btn btn-info read-more btn-sm" v-if="!readMoreActivated" @click="activateReadMore">
            <i class="mdi mdi-arrow-down"></i>
            </a>
        </div>
        <span v-if="readMoreActivated" v-html="this.text"></span>
        <br />
        <div class="divbutton">
            <a class="btn btn-info read-more btn-sm" v-if="readMoreActivated" @click="deactivateReadMore">
            <i class="mdi mdi-arrow-up"></i>
            </a>
        </div>
    </div>
</template>
<script>
export default {
    name: "Readmore",
    props: [ 'text' ],
    data() {
        return {
            readMoreActivated: false
        }
    },
    computed: {
        visibleText() {
            if (this.text === undefined) return ''
            if (this.text.length < 100) return this.text

            return this.text.slice(0, 100)
        } 
    },
    methods: {
    activateReadMore(){
        this.readMoreActivated = true;
    },
    deactivateReadMore(){
        this.readMoreActivated = false;
    },
    }
}
</script>
<style>
    .read-more{
        color: white !important;
    }
    .divbutton{
        text-align: center;
        margin-top: 10px;
    }
</style>